var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-34.95 -137.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.547,19H4.453A4.458,4.458,0,0,1,0,14.547V4.453A4.458,4.458,0,0,1,4.453,0H14.547A4.458,4.458,0,0,1,19,4.453V14.547A4.458,4.458,0,0,1,14.547,19ZM4.453,1.484A2.972,2.972,0,0,0,1.484,4.453V14.547a2.972,2.972,0,0,0,2.969,2.969H14.547a2.972,2.972,0,0,0,2.969-2.969V4.453a2.972,2.972,0,0,0-2.969-2.969ZM14.881,16.031H13.248a.742.742,0,1,1,0-1.484h1.633a.742.742,0,1,1,0,1.484Zm-1-2.893h-6.2a.743.743,0,0,1,0-1.485h6.2a.742.742,0,1,1,0,1.485ZM7.088,4.49H3.971a.742.742,0,1,1,0-1.484H7.088a.742.742,0,1,1,0,1.484Z",
    transform: "translate(34.95 137.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M10.279,4.342H5.047a.742.742,0,1,1,0-1.483h5.232a.742.742,0,1,1,0,1.483Zm-2.6-2.857H.743A.743.743,0,1,1,.743,0H7.682a.743.743,0,0,1,0,1.485Z",
    transform: "translate(39.663 143.351)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.3b714b9336416acdf9f216534e1e4ff6.svg";
export { ForwardRef as ReactComponent };